import { gql } from '@apollo/client';

export const COMMAND_EXECUTION_ERROR = gql`
  subscription commandExecutionError {
    commandExecutionError {
      code
    }
  }
`;
